import { createContext, useContext } from 'react';

// Provided default values are only there for typescript to be happy.
// They will never be used.
const AppContext = createContext({
    shopBundle: 'zooplus',
    domain: 'zooplus.com',
    locale: 'zu',
    csrfToken: undefined,
});
const useAppContext = () => useContext(AppContext);
var AppContextProvider = AppContext.Provider;

export { AppContextProvider as default, useAppContext };
//# sourceMappingURL=AppContextProvider.js.map
